import React, { useState, useEffect, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import "./MenuSection.css";
import menuBeatsRest from "../../data/menuData.beats-rest.json";
import menuBeatsRest2 from "../../data/menuData.beats-rest-2.json";

const MENUS = {
  "oblatos": {
    label: "Beats Rest - Oblatos",
    data: menuBeatsRest,
  },
  "alcalde": {
    label: "Beats Rest - Alcalde",
    data: menuBeatsRest2,
  },
};

const MenuSection = () => {
  const [activeCategory, setActiveCategory] = useState("all");
  const [selectedItem, setSelectedItem] = useState(null);
  const sectionRef = useRef(null);

  const { locationSlug } = useParams();
  const history = useHistory();

  // Determine current location slug and menu data
  const currentSlug = MENUS[locationSlug] ? locationSlug : "oblatos";
  const currentMenu = MENUS[currentSlug];
  const menuData = currentMenu.data;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentSlug]);

  const categories = Object.keys(menuData);

  const tabsRef = useRef(null);

  const scrollLeft = () => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({ left: -250, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({ left: 250, behavior: "smooth" });
    }
  };

  const handleLocationChange = (slug) => {
    if (slug !== currentSlug) {
      history.push(`/menu/${slug}`);
    }
  };

  return (
    <section
      ref={sectionRef}
      className="menu-section compact"
    >
      {/* Hero Info + Tabs (Modern Unified Header) */}
      <div className="hero-info sticky-hero">
        <div className="hero-info-left">
          <div className="profile-pic">
            <img
              src={`${process.env.PUBLIC_URL}/assets/profile.jpg`}
              alt="Beats Rest Logo"
            />
          </div>
          <div className="text-content">
            <h1 className="restaurant-name">BEATS REST</h1>
            <p className="restaurant-location">
              {currentSlug === "oblatos"
                ? "Beats Urban Eatery · Plaza Roja 3er Piso, Calle José María Narvaez #1029 Blanco y Cuellar, Guadalajara, Jalisco 44730"
                : "Beats Urban Eatery · Gabriela Mistral #966, Alcalde Barranquitas, 44270 Guadalajara, Jal., Mexico"}
            </p>

            <div className="location-toggle">
              <button
                type="button"
                className={currentSlug === "oblatos" ? "location-btn active" : "location-btn"}
                onClick={() => handleLocationChange("oblatos")}
              >
                Oblatos
              </button>
              <button
                type="button"
                className={currentSlug === "alcalde" ? "location-btn active" : "location-btn"}
                onClick={() => handleLocationChange("alcalde")}
              >
               Alcalde
              </button>
            </div>
          </div>
        </div>

        {/* Category Tabs with Scroll Arrows */}
        <div className="menu-tabs-wrapper">
          <button className="menu-scroll-btn left" onClick={scrollLeft}>‹</button>

          <div className="menu-tabs sticky-tabs" ref={tabsRef}>
            <button
              key="all"
              className={`menu-tab ${activeCategory === "all" ? "active" : ""}`}
              onClick={() => {
                setActiveCategory("all");
                sectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
            >
              Todo
            </button>

            {categories.map((category) => (
              <button
                key={category}
                className={`menu-tab ${activeCategory === category ? "active" : ""}`}
                onClick={() => {
                  setActiveCategory(category);
                  sectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
              >
                {typeof category === "string"
                  ? category
                      .replace(/_/g, " ")
                      .toLocaleLowerCase("es-ES")
                      .replace(/(^|\s)\S/g, (char) => char.toLocaleUpperCase("es-ES"))
                      .normalize("NFC")
                  : ""}
              </button>
            ))}
          </div>

          <button className="menu-scroll-btn right" onClick={scrollRight}>›</button>
        </div>
      </div>



      {/* Menu Items */}
      {activeCategory === "all"
        ? Object.keys(menuData).map((category) => (
            <React.Fragment key={category}>
              <h2 className="menu-category-title">
                {typeof category === "string"
                  ? category.replace(/_/g, " ").toLocaleUpperCase("es-ES").normalize("NFC")
                  : ""}
              </h2>
              <div className="menu-grid">
                {menuData[category].map((entry, index) => (
                  <React.Fragment key={index}>
                    {entry.category && (
                      <h3 className="drink-subcategory">{entry.category}</h3>
                    )}
                    {(entry.items || [entry]).map((item, j) => (
                      <div key={j} className="menu-card" onClick={() => setSelectedItem(item)}>
                        <div className="menu-card-info">
                          <h3>{item.name}</h3>
                          {item.description && (
                            <p className="description">{item.description}</p>
                          )}
                          {item.prices && Array.isArray(item.prices) && item.prices.length > 0 ? (
                            <p className="price">
                              ${Math.min(...item.prices.map(p => p.price)).toLocaleString("es-MX", { minimumFractionDigits: 2 })} - $
                              {Math.max(...item.prices.map(p => p.price)).toLocaleString("es-MX", { minimumFractionDigits: 2 })}
                            </p>
                          ) : item.price ? (
                            <p className="price">
                              ${item.price.toLocaleString("es-MX", { minimumFractionDigits: 2 })}
                            </p>
                          ) : null}
                        </div>
                        {item.image && (
                          <img
                            src={process.env.PUBLIC_URL + item.image}
                            alt={item.name}
                            className="menu-image"
                          />
                        )}
                      </div>
                    ))}
                  </React.Fragment>
                ))}
              </div>
            </React.Fragment>
          ))
        : menuData[activeCategory] && menuData[activeCategory].length > 0 ? (
            <div className="menu-grid">
              {menuData[activeCategory].map((entry, index) => (
                <React.Fragment key={index}>
                  {entry.category && (
                    <h3 className="drink-subcategory">{entry.category}</h3>
                  )}
                  {(entry.items || [entry]).map((item, j) => (
                    <div key={j} className="menu-card" onClick={() => setSelectedItem(item)}>
                      <div className="menu-card-info">
                        <h3>{item.name}</h3>
                        {item.description && (
                          <p className="description">{item.description}</p>
                        )}
                        {item.prices && Array.isArray(item.prices) && item.prices.length > 0 ? (
                          <p className="price">
                            ${Math.min(...item.prices.map(p => p.price)).toLocaleString("es-MX", { minimumFractionDigits: 2 })} - $
                            {Math.max(...item.prices.map(p => p.price)).toLocaleString("es-MX", { minimumFractionDigits: 2 })}
                          </p>
                        ) : item.price ? (
                          <p className="price">
                            ${item.price.toLocaleString("es-MX", { minimumFractionDigits: 2 })}
                          </p>
                        ) : null}
                      </div>
                      {item.image && (
                        <img
                          src={process.env.PUBLIC_URL + item.image}
                          alt={item.name}
                          className="menu-image"
                        />
                      )}
                    </div>
                  ))}
                </React.Fragment>
              ))}
            </div>
          ) : (
            <p className="no-items">No hay elementos disponibles en esta categoría.</p>
          )}

      {selectedItem && (
        <div className="menu-modal-overlay" onClick={() => setSelectedItem(null)}>
          <div className="menu-modal" onClick={(e) => e.stopPropagation()}>
            {selectedItem.image && (
              <img
                src={process.env.PUBLIC_URL + selectedItem.image}
                alt={selectedItem.name}
                className="menu-modal-image"
              />
            )}

            <h2>{selectedItem.name}</h2>

            {selectedItem.description && <p>{selectedItem.description}</p>}

            {/* Multi-size / multi-price support */}
            {selectedItem.prices && Array.isArray(selectedItem.prices) && (
              <div className="menu-modal-prices">
                {selectedItem.prices.map((p, i) => (
                  <p key={i}>
                    <strong>{p.quantity}:</strong> ${p.price.toLocaleString("es-MX", { minimumFractionDigits: 2 })}
                  </p>
                ))}
              </div>
            )}

            {/* Sauce / flavor options */}
            {selectedItem.options && Array.isArray(selectedItem.options) && (
              <div className="menu-modal-options">
                <h4>Selecciones:</h4>
                <ul>
                  {selectedItem.options.map((opt, i) => (
                    <li key={i}>{opt}</li>
                  ))}
                </ul>
              </div>
            )}

            {/* Default price display (for items without multiple prices) */}
            {!selectedItem.prices && selectedItem.price && (
              <p className="menu-modal-price">
                ${selectedItem.price.toLocaleString("es-MX", { minimumFractionDigits: 2 })}
              </p>
            )}

            <button onClick={() => setSelectedItem(null)}>Cerrar</button>
          </div>
        </div>
      )}
    </section>
  );
};

export default MenuSection;